var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Box, CircularProgress, FormControl, FormHelperText, Grid, InputAdornment, InputLabel, OutlinedInput, TextField, Typography, debounce, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useLazyFindMachineBySerialNumberQuery } from '../../../application/features/machines/machine-api';
import { useAnalyzeImageMutation, useLazyFetchOcrResultQuery } from '../../../application/features/microsoft-vision/microsoft-vision-api';
import useTranslate from '../../../localization/helpers';
import FileUpload from '../FileUpload';
var FindBySerialNumber = function (_a) {
    var control = _a.control, setValue = _a.setValue, errors = _a.errors, isSuperAdmin = _a.isSuperAdmin, isMachineLoading = _a.isMachineLoading, fileLoading = _a.fileLoading, setIsMachinesLoading = _a.setIsMachinesLoading, onSubmit = _a.onSubmit, setFileLoading = _a.setFileLoading;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var theme = useTheme();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var _c = __read(useState(''), 2), machineSearchTerm = _c[0], setMachineSearchTerm = _c[1];
    var _d = __read(useState(), 2), currentFile = _d[0], setCurrentFile = _d[1];
    var _e = __read(useState(0), 2), attempts = _e[0], setAttempts = _e[1];
    var _f = __read(useState(''), 2), fileErrorText = _f[0], setFileErrorText = _f[1];
    var _g = __read(useState(''), 2), fileInfoText = _g[0], setFileInfoText = _g[1];
    var _h = __read(useLazyFindMachineBySerialNumberQuery(), 2), findMachineBySerialNumber = _h[0], _j = _h[1], _k = _j.data, machinesBySerialNumber = _k === void 0 ? [] : _k, isMachineFetching = _j.isFetching;
    useEffect(function () {
        setIsMachinesLoading(isMachineFetching);
    }, [isMachineFetching, setIsMachinesLoading]);
    var _l = __read(useAnalyzeImageMutation(), 2), analyzeImage = _l[0], operationLocation = _l[1].data;
    var _m = __read(useLazyFetchOcrResultQuery(), 1), fetchOcrResult = _m[0];
    useEffect(function () {
        if (operationLocation) {
            var intervalId_1 = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
                var ocrResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchOcrResult(operationLocation).unwrap()];
                        case 1:
                            ocrResult = _a.sent();
                            if (!ocrResult) {
                                setFileErrorText(translate('validations.imageClarityError'));
                                setFileInfoText('');
                                clearInterval(intervalId_1);
                                setFileLoading(false);
                            }
                            else if (ocrResult !== 'running') {
                                clearInterval(intervalId_1);
                                setFileLoading(false);
                                extractSerialNumber(ocrResult);
                            }
                            return [2 /*return*/];
                    }
                });
            }); }, 1000);
            return function () { return clearInterval(intervalId_1); };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [operationLocation, fetchOcrResult]);
    var getMachineSearchResults = useMemo(function () {
        return debounce(function (serialNumber) {
            if (serialNumber) {
                findMachineBySerialNumber(serialNumber);
            }
        }, 1000);
    }, [findMachineBySerialNumber]);
    useEffect(function () {
        getMachineSearchResults(machineSearchTerm);
    }, [getMachineSearchResults, machineSearchTerm]);
    var extractSerialNumber = function (ocrText) {
        if (ocrText && ocrText !== 'running') {
            var serialNumberPattern = /(?:S\/N|SN|Ser\.? No\.?|Serial No\.?|Serial #|Serial No:|Serial Number|Serial Nº|Serial N|Serienummer|ID No\.?|ID Number|Equipment Number|Product Number|Product No|Asset Number|Asset ID|Identificatie Nr)\s+[:\-#\s]*\s*([^\s]+)/i;
            var match = serialNumberPattern.exec(ocrText);
            if (match) {
                var extractedText = match[1];
                var containsNumber = /\d/.test(extractedText);
                if (isSuperAdmin) {
                    setMachineSearchTerm('');
                    setValue('id', '');
                    setValue('modelNumber', '');
                }
                if (containsNumber) {
                    setValue('serialNumber', extractedText, { shouldValidate: true });
                    setFileInfoText(translate('validations.serialWarning'));
                    if (isSuperAdmin) {
                        setMachineSearchTerm(extractedText);
                    }
                }
                else if (attempts < 1) {
                    setAttempts(attempts + 1);
                    recognizeText(currentFile, 'natural');
                }
                else {
                    setFileInfoText('');
                    setFileErrorText(translate('validations.serialNotFoundError'));
                }
            }
            else if (attempts < 1) {
                setAttempts(attempts + 1);
                recognizeText(currentFile, 'natural');
            }
            else {
                setFileInfoText('');
                setFileErrorText(translate('validations.serialNotFoundError'));
            }
        }
    };
    var recognizeText = function (file, readingOrder) { return __awaiter(void 0, void 0, void 0, function () {
        var arrayBuffer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setValue('serialNumber', '');
                    setFileErrorText('');
                    setFileInfoText('');
                    setFileLoading(true);
                    setCurrentFile(file);
                    return [4 /*yield*/, file.arrayBuffer()];
                case 1:
                    arrayBuffer = _a.sent();
                    return [4 /*yield*/, analyzeImage({ imageData: arrayBuffer, readingOrder: readingOrder })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onImageChange = function (file, readingOrder) {
        setAttempts(0);
        recognizeText(file, readingOrder);
    };
    return (_jsx(Box, { children: _jsxs(Grid, { container: true, spacing: 3, children: [isXs ? (_jsx(Grid, { container: true, size: { xs: 12 }, children: _jsx(FormControl, { variant: 'outlined', fullWidth: true, size: 'small', children: _jsx(FileUpload, { onChange: function (file) { return onImageChange(file); }, allowedFileTypes: ['PNG', 'JPG', 'JPEG'], allowedFileTypesText: 'PNG, JPG, JPEG', uploadLabel: translate('assets.uploadImageText'), error: fileErrorText, infoText: fileInfoText }) }) })) : (_jsx(Grid, { container: true, size: { xs: 12 }, children: _jsx(FormControl, { variant: 'outlined', fullWidth: true, size: 'small', children: _jsx(FileUpload, { onChange: function (file) { return onImageChange(file); }, allowedFileTypes: ['PNG', 'JPG', 'JPEG'], allowedFileTypesText: 'PNG, JPG, JPEG', uploadLabel: translate('assets.uploadImageText'), error: fileErrorText, infoText: fileInfoText }) }) })), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Box, { display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', children: _jsxs(Typography, { variant: 'body2', children: [" ", translate('common.or')] }) }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'serialNumber', control: control, rules: {
                            validate: function (value, formValue) {
                                return (!!value ||
                                    !!formValue.id ||
                                    tWithField('validations.fieldIsRequired', 'assets.serialNumber'));
                            },
                            maxLength: {
                                value: 256,
                                message: translate('validations.maximumCharactersAllowed', { count: 256 })
                            }
                        }, render: function (_a) {
                            var _b;
                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                            return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { htmlFor: 'serial-number', children: tWithFunction('actions.addFunction', 'assets.serialNumber') }), _jsx(OutlinedInput, { id: 'serial-number', fullWidth: true, disabled: isMachineLoading || fileLoading, label: isXs
                                            ? tWithFunction('actions.enterFunction', 'assets.serialNumbers')
                                            : tWithFunction('actions.enterFunction', 'assets.serialNumber'), placeholder: 'SN-1234567-CF8', error: !!errors.serialNumber, value: value, onChange: function (e) {
                                            onChange(e.target.value);
                                            if (isSuperAdmin) {
                                                setValue('id', '');
                                                setValue('modelNumber', '');
                                                setMachineSearchTerm(e.target.value);
                                            }
                                        }, onKeyDown: function (e) {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                onSubmit();
                                            }
                                        }, endAdornment: isSuperAdmin && isMachineFetching ? (_jsx(InputAdornment, { position: 'end', children: _jsx(CircularProgress, { color: 'inherit', size: 30 }) })) : null }), _jsx(FormHelperText, { error: true, children: (_b = errors.serialNumber) === null || _b === void 0 ? void 0 : _b.message })] }));
                        } }) }), isSuperAdmin && machinesBySerialNumber.length > 1 && (_jsx(Grid, { size: { xs: 12 }, children: _jsx(FormControl, { fullWidth: true, children: _jsx(Controller, { name: 'id', control: control, rules: {
                                required: tWithField('validations.fieldIsRequired', 'common.asset')
                            }, render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, value = _b.value, error = _a.fieldState.error;
                                return (_jsx(Autocomplete, { options: machinesBySerialNumber, isOptionEqualToValue: function (option, value) { return option.id === (value === null || value === void 0 ? void 0 : value.id); }, getOptionLabel: function (option) {
                                        return "".concat(option.name, " (").concat(option.documents, " ").concat(translate('common.documents'), ")");
                                    }, fullWidth: true, value: machinesBySerialNumber.find(function (machine) { return machine.id === value; }) || null, onChange: function (_, newValue) {
                                        onChange((newValue === null || newValue === void 0 ? void 0 : newValue.id) || '');
                                        setValue('modelNumber', (newValue === null || newValue === void 0 ? void 0 : newValue.modelNumber) || '');
                                    }, renderOption: function (props, option) { return (_jsxs("li", __assign({}, props, { children: [option.name, "\u00A0", _jsxs("span", { style: { color: '#637381' }, children: ["(", option.documents, " ", translate('common.documents'), ")"] })] }))); }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { placeholder: translate('actions.select'), label: translate('common.asset'), variant: 'outlined', error: !!error, helperText: error === null || error === void 0 ? void 0 : error.message }))); } }));
                            } }) }) }))] }) }));
};
export default FindBySerialNumber;
